import { render, staticRenderFns } from "./OnlCgformCopyList.vue?vue&type=template&id=384814c6&scoped=true&"
import script from "./OnlCgformCopyList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformCopyList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformCopyList.vue?vue&type=style&index=0&id=384814c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384814c6",
  null
  
)

export default component.exports